<template>
  <div class="c-empty-page">
    <div class="container">
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CEmptyPage',
  props: {
    text: {
      type: String,
      default: 'Список пуст',
    },
  },
}
</script>

<style lang="scss" scoped>
.c-empty-page {
  p {
    padding-top: 50px;
    text-align: center;
    font-style: italic;
    color: rgba(127,127,127,0.7);
    font-weight: normal;
    font-size: 1em;
  }
}
</style>
